import { ChangeDetectionStrategy, Component, effect, inject, OnInit, signal } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { BaseController } from '../../../core/abstractions/base.controller';
import { ReportModel } from '../../../models/report.model';
import { ReportsService } from '../../../services/reports.service';
import { ReportsResource } from '../../../services/resources/reports.resource';
import { AppSessionStorage } from '../../../services/storage/app.session-storage';
import { SecurityStorage } from '../../../services/storage/security.storage';

@Component({
    selector: 'sl-reports-view',
    templateUrl: './reports-view.component.html',
    styleUrls: ['./reports-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportsViewComponent extends BaseController<ReportModel> implements OnInit {
    readonly hasReportLoaded = signal(false);
    readonly reportUrl = signal<string>('');

    protected override readonly _entityResource = inject(ReportsResource);

    private readonly securityStorageService = inject(SecurityStorage);
    private readonly settingSessionStorage = inject(AppSessionStorage);
    private readonly reportsService = inject(ReportsService);

    constructor() {
        super();

        this.shouldLoadSummary = false;

        effect(
            () => {
                if (!this.isLoading() && !!this.recordId()) {
                    const ctx = this.settingSessionStorage.getCurrentContext();
                    const token = this.securityStorageService.getUserInfo()?.token ?? '';

                    this.reportsService.setLoadedReportId(this.recordId()!);
                    this.reportUrl.set(`${environment.reportingUrl}/report-viewer/?rid=${this.recordId()!}&api_key=${token}&ctx=${ctx}`);
                }
            },
            { allowSignalWrites: true }
        );
    }

    override ngOnInit(): void {
        super.ngOnInit();
        const urlChangeSub = this.urlChange.subscribe(() => this.hasReportLoaded.set(false));
        this.addSubscriptions(urlChangeSub);
    }

    markReportAsLoaded(): void {
        this.hasReportLoaded.set(true);
    }
}
